<template>
  <div>
    <onaydialog ref="onaydialog"></onaydialog>


    <v-dialog scrollable="" persistent v-model="dialog" max-width="550px">
      <v-card flat color="grey lighten-3">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text"> {{ $t('Document-Processes') }}  </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>

          <v-flex pb-2 xs12 sm12 md12>
            <v-card flat class="white--text">
              <v-card color="white" flat="">
                <v-card-actions>

                  <v-layout justify-space-between column>

                    <v-layout row="" wrap="">
                      <v-form ref="formek" v-model="valid" lazy-validation>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-icon v-if="islem =='guncelle'" medium="" color="grey">edit</v-icon>
                              <v-icon v-if="islem =='yeni'" medium="" color="grey">add</v-icon> &nbsp;
                              <span  v-if="islem =='yeni'" class=" font-weight-regular grey--text title">{{this.$t('Document-Add')}}</span>
                                <span  v-if="islem =='guncelle'" class=" font-weight-regular grey--text title">{{this.$t('Document-Edit')}}</span>
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 sm4 md12>
                              <v-text-field v-model="DosyaInput.Aciklama" :rules="[v => !!v || $t('Mandatory-Areas')]"
                                hide-details="" :label="$t('Description')">
                              </v-text-field>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-textarea v-model="DosyaInput.UzunAciklama" :label="$t('Long-Explanation')"></v-textarea>

                            </v-flex>
                            <v-flex xs12 sm12 md4>
                              <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data"
                                v-model="validform" lazy-validation>
                                <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="file" ref="file"
                                  multiple v-on:change="handleFileUpload()" />
                              </v-form>
                              <v-btn flat :loading="false" :disabled="false" color="grey" @click="addFiles()">
                                <v-icon small color="info" left>attach_file</v-icon>{{$t('Select-File')}}
                              </v-btn>
                            </v-flex>
                            <v-flex xs12 sm12 md8>
                              <v-layout fill-height align-center>
                                <span class="grey--text body-2	"> {{ secilendosya}}</span>
                              </v-layout>
                            </v-flex>
                            <ul id="ulList">
                            </ul>

                            <v-flex xs12 pt-2 sm12 md12>
                              <v-layout justify-end>
                                <v-btn v-if="islem=='yeni'" flat @click="dosyaekleKaydet()" color="info">{{$t('Add-to-List')}}
                                </v-btn>
                                  <v-btn v-if="islem=='guncelle'" flat @click="islemiptal()" color="info"> {{ $t('Cancel-Process') }} </v-btn>
                                <v-btn v-if="islem=='guncelle'" flat @click="dosyaGuncelle()" color="info">
                                  {{ $t('Update') }}</v-btn>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                      </v-form>

                    </v-layout>


                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-flex pb-2 v-if="islem=='yeni'"  xs12 sm12 md12>
            <v-card flat class="white--text">
              <v-card color="white" flat="">
                <v-card-actions>


                  <v-layout row="" wrap="">
                    <v-flex xs12 pb-1 sm12 md12>
                      <v-icon medium="" color="grey">view_list</v-icon> &nbsp;
                      <span class=" font-weight-regular grey--text title">{{$t('Document-List')}}</span>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions>
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr item>
                            <td class="text-xs-left">{{ props.item.Id }}</td>
                            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                            <td class="text-xs-left">{{ props.item.UzunAciklama }}</td>
                            <td class="justify-center layout px-0">
                              <v-tooltip bottom>
                                <v-btn icon small slot="activator" flat @click="dosyasil(props.item)">
                                  <v-icon small color="red">delete</v-icon>
                                </v-btn>
                                <span> {{ $t('Delete') }} </span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <v-btn icon small slot="activator" flat @click="Getir(props.item)">
                                  <v-icon small color="green">edit</v-icon>
                                </v-btn>
                                <span> {{ $t('Edit') }} </span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <v-btn icon small slot="activator" flat @click="dosyagetir(props.item)">
                                  <v-icon small color="info">find_in_page</v-icon>
                                </v-btn>
                                <span> {{ $t('Show-Attachment') }} </span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <div v-if="islem=='yeni'" class="flex md12">


          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="islem=='yeni'" color="primary" flat @click="dialog = false">
            {{$t('Close')}} </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tool from "../../coper/tools"
  import yuzdeinput from '../../customcomp/yuzdeinput'
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"

  import helpers from "@/components/app/customcomp/helpers.js"


  export default {

    props: ["value"],
    components: {
      yuzdeinput,
      onaydialog
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      dosyagetir(a) {
        var prm = {
          GuiID: a.GuiID,
        }

        tool.api_post_FileDownload(this, "Coper/DownloadFile", prm).then(

          response => {
            tool.CreateDownloadLink(response, 'EkliDosya');
          },

          response => {
             this.text1 = 'Dosya bulunamadı.'
                    this.snackbar = true
          }
        );
      },
      handleFileUpload() {
        this.files = []


        if (this.$refs.file.files != [] && this.$refs.file.files != null) {
          var uploadedFiles = this.$refs.file.files;

          var fp = document.getElementById('file');

          var lg = uploadedFiles.length; // get length
          if (lg > 0) {
            this.secilendosya = lg +  " " + this.$t('pcs-of-files-selected')
          } else {
            this.secilendosya = this.$t('file-has-been-chosen')
          }
          document.getElementById('ulList').innerHTML = '';

          var items = uploadedFiles
          var fragment = "";

          if (lg > 0) {
            for (var i = 0; i < lg; i++) {
              var fileName = items[i].name; // get file name
              var fileSize = items[i].size; // get file size
              var fileType = items[i].type; // get file type

              // append li to UL tag to display File info
              fragment += "<li>" + fileName + " (<b>" + fileSize + "</b> bytes)" // - Type :" + fileType + "</li>";
            }
            document.getElementById('ulList').innerHTML = fragment;
            //contentWindow.document.body.innerHTML = response.body;
            // $("#ulList").append(fragment);
          }

          if (uploadedFiles.length > 0) {

            for (var i = 0; i < uploadedFiles.length; i++) {
              this.files.push(uploadedFiles[i]);
            }

          } else {

          }
        }

      },
      addFiles() {
        this.$refs.file.click();
      },
      islemiptal() {
        this.islem = 'yeni'
        this.DosyaInput.KDV = 0
        this.DosyaInput.EkliSaticiKod = null
      },
      Getir(val) {
        this.DosyaInput.Aciklama = val.Aciklama
        this.DosyaInput.UzunAciklama = val.UzunAciklama
        this.silinecekkayit = val.Id
        this.islem = 'guncelle'

      },
      dosyaGuncelle() {
        if (this.$refs.formek.validate()) {


          let prm = {
            Id:this.silinecekkayit,
            SaticiTipi: this.Satici.Tip,
            SaticiKodu: this.Satici.Kod,
            Aciklama: this.DosyaInput.Aciklama,
            UzunAciklama: this.DosyaInput.UzunAciklama
          }

          tool.api_file_post2(this, "Coper/SaticiEkliDosyalarDegistir", this.files, prm).then(

            response => {

              var params = {
                SaticiTipi: this.Satici.Tip,
                SaticiKodu: this.Satici.Kod
              }


              tool.http_post(this, "SaticiEkliDosyalarList", params).then(
                response => {

                  if (response.body.Status == true) {

                    this.items = response.body.data
                    this.text1 = 'Kayıt güncellendi. '
                    this.snackbar = true

                    this.DosyaInput.Aciklama = null
                    this.DosyaInput.UzunAciklama = null
                    this.islem='yeni'

                  } else {
                    this.text1 = 'Service Unavailable '
                    this.snackbar = true
                  }
                },
                response => {

                  this.text1 = 'Service Unavailable '
                  this.snackbar = true
                }
              );



            },

            response => {

              this.text1 = 'Service Unavailable '
              this.snackbar = true

            }
          );




        }
      },
      dosyasil(val) {
        this.$refs.onaydialog.open('Bu kayıtı silmek istediğinize eminmisiniz', 1).then(sonuc => {

          if (sonuc == true) {

            var prm = {

              Id: val.Id,

            };


            tool.api_post(this, "Coper/SaticiEkliDosyalarSil", prm).then(
              response => {

                if (response.body.Status == true) {

                  var params = {
                    SaticiTipi: this.Satici.Tip,
                    SaticiKodu: this.Satici.Kod
                  }


                  tool.http_post(this, "SaticiEkliDosyalarList", params).then(
                    response => {

                      if (response.body.Status == true) {

                        this.text1 = 'Kayıt silindi. '
                        this.snackbar = true

                        this.items = response.body.data

                      } else {

                        this.text1 = 'Service Unavailable '
                        this.snackbar = true
                      }
                    },
                    response => {

                      this.text1 = 'Service Unavailable '
                      this.snackbar = true
                    }
                  );


                } else {
                  var str = ''
                  response.body.ErrorList.forEach(element => {
                    str += element + ' , '
                  });
                  this.text1 = str
                  this.snackbar = true
                }
              },
              response => {
                this.text1 = 'Service Unavailable '
                this.snackbar = true
              }
            );


          }
        });
      },
      dosyaekleKaydet() {
        if (this.$refs.formek.validate()) {

          if (this.files.length > 0) {

            let prm = {
              SaticiTipi: this.Satici.Tip,
              SaticiKodu: this.Satici.Kod,
              Aciklama: this.DosyaInput.Aciklama,
              UzunAciklama: this.DosyaInput.UzunAciklama
            }

            tool.api_file_post2(this, "Coper/SaticiEkliDosyalarEkle", this.files, prm).then(

              response => {

                var params = {
                  SaticiTipi: this.Satici.Tip,
                  SaticiKodu: this.Satici.Kod
                }


                tool.http_post(this, "SaticiEkliDosyalarList", params).then(
                  response => {

                    if (response.body.Status == true) {

                      this.items = response.body.data
                      this.text1 = 'Kayıt kayıt edildi. '
                      this.snackbar = true

                      this.DosyaInput.Aciklama = null
                      this.DosyaInput.UzunAciklama = null

                    } else {
                      this.text1 = 'Service Unavailable '
                      this.snackbar = true
                    }
                  },
                  response => {

                    this.text1 = 'Service Unavailable '
                    this.snackbar = true
                  }
                );

                //this.items = response.body;


              },

              response => {

                this.status = tool.responseToStatus(response);

              }
            );



          } else {
            this.text1 = this.$t('Please-Select-a-File')
            this.snackbar = true
          }

        }
      },
      saticigetir(ara) {
        var params = {
          SaticiTipi: 10, //Acente
          Id: null, //eğer varsa ID, nokta atışı yapmak için. varsa 3. ve 4. parametreler işlevsiz kalır
          Kod: null, //eğer varsa Kod, Nokta atışı yapmak için. varsa 4. parametre işlevsiz kalır
          Aciklama: ara //Kullanıcının arama yapması için (maksimum 10 kayıt getirir)
        }

        tool.http_post(this, "SimpleSaticiAra", params).then(
          response => {

            if (response.body.Status == true) {
              this.statesatici = response.body.data
              this.loadingacente = false

            } else {
              this.text1 = 'Service Unavailable ara'
              this.snackbar = true
              this.loadingacente = false
            }
          },
          response => {
            this.text1 = 'Service Unavailable ara '
            this.snackbar = true
            this.loadingacente = false
          }
        );



      },
      onay() {
        this.dialog = false
        this.resolve(true);
      },
      iptal() {
        this.resolve(false);
        this.dialog = false
      },


      open(tip, kod) {

        this.Satici.Kod = kod
        this.Satici.Tip = tip


        var params = {
          SaticiTipi: tip,
          SaticiKodu: kod
        }


        tool.http_post(this, "SaticiEkliDosyalarList", params).then(
          response => {

            if (response.body.Status == true) {

              this.items = response.body.data

            } else {

              this.text1 = 'Service Unavailable list'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable lit'
            this.snackbar = true
          }
        );

        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        files: [],
        secilendosya: null,
        validform: true,
        islem: 'yeni',
        silinecekkayit: null,
        Satici: {
          Tip: null,
          Kod: null
        },
        valid: true,
        DosyaInput: {
          SaticiTipi: null,
          SaticiKodu: null,
          Aciklama: null,
          UzunAciklama: null,
          Dosya: [],
          FileName: null,
          LocalFileName: null,
        },
        loadingsatici: false,
        statesatici: [],
        searchsatici: null,

        headersservis: [{
            text: 'İd',
            value: 'Id'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',
          },
          {
            text: this.$t('Long-Explanation'),
            value: 'UzunAciklama',
          },

          {
            text: '',
            value: '',
          }
        ],
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialog: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {
      searchsatici(val) {
        val && this.saticigetir(val)
      },

    },
  }




  function beforeMount() {



  }
</script>